import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=cb2e6470"
import script from "./page-not-found.vue?vue&type=script&lang=js"
export * from "./page-not-found.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports